import React, { useState, useEffect } from "react";
import * as styles from "./RadioHelper.module.scss";
import classNames from "classnames";
import PropTypes from "prop-types";

const RadioHelper = (props) => {
	const {
		label,
		name,
		id,
		value,
		defaultValue = "",
		defaultChecked,
		onChange,
		field,
		form,
		children,
		disabled,
		fullHeight,
	} = props;

	const [isActive, setIsActive] = useState(field ? field.value === value : defaultChecked);
	const RadioHelperClassName = classNames({
		[styles["radio-helper"]]: true,
		[props.className]: !!props.className,
	});

	useEffect(() => {
		if (field) {
			setIsActive(field.value === value);
		}
	}, [field && field.value]);

	useEffect(() => {
		if (name || field.name) {
			const inputName = field ? field.name : name;
			document
				.querySelector(`input[name='${CSS.escape(inputName)}']`)
				.addEventListener("radio-change", (event) => {
					setIsActive(event.detail === value);
				});
		}

		if (field) {
			setIsActive(field.value === value);
		} else {
			setIsActive(defaultValue === value);
		}
	}, []);

	useEffect(() => {
		if (field) {
			setIsActive(field.value === value);
		} else {
			setIsActive(defaultValue === value);
		}
	}, [defaultValue]);

	const fieldName = field ? field.name : name;

	return (
		<div className={RadioHelperClassName}>
			{children({
				isActive,
				fullHeight,
				id,
				label,
			})}
			<input
				type="radio"
				id={id}
				name={fieldName}
				value={field ? field.value : value}
				disabled={disabled}
				checked={field ? field.value === value : undefined}
				defaultChecked={defaultChecked}
				onChange={(event) => {
					if (form && field) {
						form.setFieldValue(field.name, value);
					}

					if (name || field.name) {
						const customEvent = new CustomEvent("radio-change", {
							detail: event.currentTarget.value,
						});

						document.querySelector(`input[name='${CSS.escape(fieldName)}']`).dispatchEvent(customEvent);
					}

					if (onChange) {
						onChange({
							value: value,
						});
					}

					setIsActive(event.currentTarget.value === value);
				}}
			/>
		</div>
	);
};

RadioHelper.propTypes = {
	label: PropTypes.string.isRequired,
	name: PropTypes.string,
	id: PropTypes.string,
	value: PropTypes.any,
	defaultValue: PropTypes.any,
	hasError: PropTypes.bool,
	onChange: PropTypes.func,
	children: PropTypes.func,
	disabled: PropTypes.bool,
	fullHeight: PropTypes.bool,
};

export default RadioHelper;
